<div class="card" *blockUI="'section-block'">
    <div class="col-12 d-flex justify-content-between align-items-center p-25">
        <a href="#/admin/delivery-create">
            <button class="btn btn-primary" rippleEffect>
                <i data-feather="plus" class="d-sm-none d-inline-block"></i>
                <span class="d-none d-sm-inline-block">Cihaz Teslim Al</span>
            </button>
        </a>
        <div class="col-xl-3 col-md-6 col-sm-12">
            <ng-select [items]="companies" bindValue="id" bindLabel="companyName" placeholder="Firma Seç"
                [(ngModel)]="selectedCompanyId" (change)="onCompanySelect($event)"></ng-select>
        </div>
        <div class="col-md-3 col-sm-12">
            <div class="input-group">
                <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
                    placeholder="yyyy-mm-dd - yyyy-mm-dd" [value]="displayDateRange()" (click)="datepicker.toggle()"
                    (dateSelect)="onDateSelection($event)" [autoClose]="'outside'" [dayTemplate]="rangeSelectionDP"
                    outsideDays="hidden" [startDate]="fromDate!" />
                <ng-template #rangeSelectionDP let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                        [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                        (mouseleave)="hoveredDate = null">
                        {{ date.day }}
                    </span>
                </ng-template>
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary feather icon-calendar" (click)="datepicker.toggle()"
                        type="button"></button>
                </div>
            </div>
        </div>

        <div class="d-flex align-items-center">
            <button type="button" class="btn btn-icon btn-flat-danger" rippleEffect (click)="resetFilter()">
                <span [data-feather]="'trash'"></span></button>
            <label class="d-flex align-items-center mr-1">
                <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="50">50</option>
                </select>
            </label>
            <label class="d-flex align-items-center mr-1">
                <input type="search" placeholder="Bul" class="form-control" (keyup)="filterUpdate($event)"
                    (search)="filterUpdate($event)" />
            </label>
        </div>
    </div>

    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [rowHeight]="75" [scrollbarH]="true" (activate)="onActivate($event)">

        <ngx-datatable-column name="Cihaz Ad." [width]="75">
            <ng-template ngx-datatable-cell-template let-row="row">
                <ul class="device-list">
                    <li *ngFor="let item of row.deliveryDeviceKinds">
                        <strong>{{ item.typeName }}:</strong> {{ item.count }}
                    </li>
                </ul>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Firma Adı" prop="companyName" [width]="200"></ngx-datatable-column>
        <ngx-datatable-column name="Teklif No" prop="no" [width]="100"></ngx-datatable-column>
        <ngx-datatable-column name="Tarih" prop="deliveryDate" [width]="100">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.deliveryDate | date : 'dd.MM.yyyy'}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Gönderen Kişi" [width]="100">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.companyPersonName}} {{row.companyPersonLastName}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Teslim Alan" [width]="150">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.personName}} {{row.personLastName}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Cihaz Durum" [width]="120">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div *ngFor="let item of row.deviceAcceptanceStates">
                    <span class="badge" [ngClass]="{
                              'badge-info': item.name === 'Bekliyor',
                              'badge-success': item.name === 'Tamamlandı',
                              'badge-danger': item.name === 'İptal Edildi',
                              'badge-warning': item.name !== 'Bekliyor' && item.name !== 'Tamamlandı' && item.name !== 'İptal Edildi'
                          }">
                        {{ item.name }} {{ item.count }}
                    </span>
                </div>
            </ng-template>
        </ngx-datatable-column>

        <!-- <ngx-datatable-column name="Cihaz Teslim." [width]="120">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div *ngFor="let item of row.deliveryDevicesIsDeliveryStautes">
                    <span class="badge" [ngClass]="item.isDeliveryStatus ? 'badge-info' : 'badge-danger'">
                        {{ item.isDeliveryStatus ? 'Teslim Edilen' : 'Teslim Edilmeyen' }} {{ item.count }}
                    </span>
                </div>
            </ng-template>
        </ngx-datatable-column> -->

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious>
                            <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>